import { useContext, useState } from "react"
import { PresetContext, PresetModal } from "Components/Preset/context"
import { useInputChange } from "Hooks/basic"
import { ArticleType } from "Types/article"
import { AppContext } from "Views/Home/context"
import { Channel } from "Types/channel"
import { InitialModal } from "Methods/modal"
import { PresetBoard } from "Types/board"

export function useAddModal() {
    const el: HTMLElement | null = document.querySelector("#board_input_modal")
    const { weChatChannel } = useContext(AppContext)
    const { presetModal, articleTypes, setPresetModal, createPreset } = useContext(PresetContext)
    const { data, text: modalTitle } = presetModal as PresetModal
    const { weekDay, place } = data
    const { day } = weekDay
    const { seq_id } = place
    const { text } = weekDay
    const { name } = place
    // 弹窗标题
    const title = modalTitle
    // 母版位置
    const timePlace = `${text} ${name}`
    // 内容
    const { text: description, handleChange } = useInputChange("")
    // 文章类型
    const articleTypesData = articleTypes.map(({ id, name }: ArticleType) => ({
        value: id, text: name,
    }))
    const [ articleType, setArticleType ] = useState<string | number>("")
    // 预约人
    const [ authorId, setAuthorId ] = useState<number>(0)
    const [ principalId, setPrincipalId ] = useState<string>("")
    // 弹窗禁用状态
    const disabled = description === "" || articleType === "" || authorId === 0
    // 确定
    const confirm = async () => {
        await createPreset({
            variables: {
                seq_id,
                author_id: Number(authorId),
                article_type_id: articleType,
                description,
                ad_weekday: day,
                channel_id: (weChatChannel as Channel).id,
                creator_id: principalId,
            },
        })
    }
    // 取消
    const cancel = () => {
        setPresetModal(null)
    }
    const { onConfirm } = useConfirmCallback({confirm, cancel})
    return {
        el, title, disabled, timePlace,
        description, handleChange,
        articleTypesData, articleType, setArticleType,
        authorId, setAuthorId, setPrincipalId,
        confirm: onConfirm, cancel,
    }
}
export function useUpdateModal() {
    const el: HTMLElement | null = document.querySelector("#board_input_modal")
    const { weChatChannel } = useContext(AppContext)
    const { presetModal, articleTypes, setPresetModal, updatePreset } = useContext(PresetContext)
    const { data, text: modalTitle } = presetModal as PresetModal
    const { weekDay, place, preset } = data
    const {
        description: initialDescription = "",
        article_type_id: initialArticleType = "",
        author,
        author_id: initialAuthorId,
        creator_id: initialPricipalId,
        id,
    } = preset as PresetBoard
    const { name: initialAuthorName = "" } = author
    const { day } = weekDay
    const { seq_id } = place
    const { text } = weekDay
    const { name } = place
    // 弹窗标题
    const title = modalTitle
    // 母版位置
    const timePlace = `${text} ${name}`
    // 内容
    const { text: description, handleChange } = useInputChange(initialDescription)
    // 文章类型
    const articleTypesData = articleTypes.map(({ id, name }: ArticleType) => ({
        value: id, text: name,
    }))
    const [ articleType, setArticleType ] = useState<string | number>(initialArticleType)
    // 预约人
    const [ authorId, setAuthorId ] = useState<number>(initialAuthorId)
    const [ principalId, setPrincipalId ] = useState<string>(initialPricipalId)
    // 弹窗禁用状态
    const disabled = description === "" || articleType === "" || authorId === 0
    // 确定
    const confirm = async () => {
        await updatePreset({
            variables: {
                id,
                seq_id,
                author_id: Number(authorId),
                article_type_id: articleType,
                description,
                ad_weekday: day,
                channel_id: (weChatChannel as Channel).id,
                creator_id: principalId,
            },
        })
    }
    // 取消
    const cancel = () => {
        setPresetModal(null)
    }
    const { onConfirm } = useConfirmCallback({confirm, cancel})
    return {
        el, title, disabled, timePlace,
        description, handleChange,
        articleTypesData, articleType, setArticleType,
        authorId, setAuthorId, setPrincipalId,
        confirm: onConfirm, cancel,
        initialAuthorName,
    }
}
interface CallbackProps {
    confirm: () => void,
    cancel: () => void,
    text?: string,
}
let confirmLock = false
export function useConfirmCallback(props: CallbackProps) {
    const { confirm, cancel } = props
    const { handleChangeModal } = useContext(AppContext)
    const { handleError } = useErrorCallback()
    const onConfirm = async () => {
        if (confirmLock) {
            return
        }
        try {
            confirmLock = true
            await confirm()
            cancel()
            handleChangeModal({
                show: true,
                type: "success",
                title: "预约成功！",
                timeout: 800,
                customButtons: [],
                onConfirm: () => {
                    handleChangeModal(InitialModal)
                },
            })
        } catch (err) {
            handleError(cancel, err)
        } finally {
            confirmLock = false
        }
    }
    return { onConfirm }
}
export function useDeleteCallback(props: CallbackProps) {
    const { confirm, cancel, text } = props
    const { handleChangeModal } = useContext(AppContext)
    const { handleError } = useErrorCallback()
    const onDelete = async () => {
        handleChangeModal({
            show: true,
            type: "warning",
            title: `确定删除预约 ${text}？`,
            showCancel: true,
            onConfirm: async () => {
                try {
                    await confirm()
                    handleChangeModal({
                        show: true,
                        type: "success",
                        title: "已删除！",
                        timeout: 800,
                        customButtons: [],
                        onConfirm: () => {
                            handleChangeModal(InitialModal)
                        },
                    })
                } catch (err) {
                    handleError(cancel, err)
                }
            }
            ,
            onCancel: () => {
                handleChangeModal(InitialModal)
            },
        })
    }
    return { onDelete }
}
export function useErrorCallback() {
    const { handleChangeModal } = useContext(AppContext)
    const handleError = (cancel: () => void, err: any) => {
        if (!navigator.onLine) {
            cancel()
            handleChangeModal({
                show: true,
                type: "warning",
                customButtons: [],
                title: "oops! 断网啦！",
                timeout: 3000,
                onConfirm: () => {
                    handleChangeModal(InitialModal)
                },
            })
            return
        }
        const { response: { data = {} } = {}, message } = err
        cancel()
        handleChangeModal({
            show: true,
            type: "warning",
            customButtons: [],
            title: data.message || message,
            timeout: 3000,
            onConfirm: () => {
                handleChangeModal(InitialModal)
            },
        })
    }
    return { handleError }
}
